import { useEffect } from "react";
import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/home/HeroSection";
import ServicesSection from "@/components/home/ServicesSection";
import BeforeAfterSection from "@/components/home/BeforeAfterSection";
import AboutOwnerSection from "@/components/home/AboutOwnerSection";
import WhyChooseSection from "@/components/home/WhyChooseSection";
import ReviewsSection from "@/components/home/ReviewsSection";
import ServiceAreaSection from "@/components/home/ServiceAreaSection";
import WoodStainingSection from "@/components/home/WoodStainingSection";
import FinalCTASection from "@/components/home/FinalCTASection";
import { setCanonical } from "@/lib/seo";

const Index = () => {
  useEffect(() => {
    document.title = "Pressure Washing Martinsburg WV | Stream Masters PW";
    setCanonical("/");
    return () => { document.title = "Stream Masters Power Washing | Professional Power Washing in WV & VA"; };
  }, []);

  return (
    <Layout>
      <HeroSection />
      <ServicesSection />
      <BeforeAfterSection />
      <AboutOwnerSection />
      <WhyChooseSection />
      <ReviewsSection />
      <ServiceAreaSection />
      <WoodStainingSection />
      <FinalCTASection />
    </Layout>
  );
};

export default Index;
